import * as React from 'react'

import {
  Box,
  Button,
  InfiniteScroll,
  SearchField,
  Spinner,
  Table,
  Text,
} from '@factorialco/deprecated-design-system'
import { ShiftManagementTemplateFragment } from 'generated/resources/graphql'
import isEmpty from 'lodash/isEmpty'

import { observer } from 'mobx-react'

import { Controls } from 'modules/core/hooks/usePaginatedQuery'
import i18n from 'modules/core/lib/i18n'

import { trackAddTemplateShiftManagementStart } from 'modules/shift_management/lib/trackEvents'

import AddShiftTemplate from './Content/AddShiftTemplate'
import ShiftTemplateTable from './Content/ShiftTemplates/Table'

interface Props {
  shiftTemplates: ShiftManagementTemplateFragment[]
  controls: Controls
  search: string
  loading: boolean
  onSearch: (event: React.ChangeEvent<HTMLInputElement>) => void
}

const ShiftTemplatesSettings = ({ shiftTemplates, controls, search, onSearch, loading }: Props) => {
  const [isModalOpen, setIsModalOpen] = React.useState(false)
  const scrollContainerRef = React.useRef<HTMLDivElement>(null)

  const onClick = () => {
    if (!isModalOpen) {
      trackAddTemplateShiftManagementStart()
    }

    setIsModalOpen(!isModalOpen)
  }

  const onClose = () => {
    setIsModalOpen(false)
  }

  const loadingSpinner = (
    <Box width="full" padding="s32" alignItems="center" justifyContent="center">
      <Spinner />
    </Box>
  )

  const templateList = shiftTemplates.map((template) => (
    <ShiftTemplateTable shiftTemplate={template} key={template.id} />
  ))

  return (
    <>
      <Box justifyContent="spaceBetween" flexDirection="row" width="full" paddingBottom="s16">
        <Box flexDirection="row" gap="s16" flexGrow>
          <Text.Header2>
            {i18n.t('shift_management.rotating_shifts.section_sub_title')}
          </Text.Header2>

          <Box>
            <SearchField
              placeholder={i18n.t('shift_management.rotating_shifts.search_by_name')}
              onSearch={onSearch}
              search={search}
              variant="regular"
            />
          </Box>
        </Box>

        <Button type="secondary" onClick={onClick} iconName="add">
          {i18n.t('shift_management.rotating_shifts.add_rotating_shifts')}
        </Button>
      </Box>

      {isEmpty(shiftTemplates) ? (
        <Table>
          <Table.Head>
            <Table.Row>
              <Table.HeadCell></Table.HeadCell>
            </Table.Row>
          </Table.Head>
          <Table.Body>
            <Table.Blank
              colSpan={2}
              text={i18n.t('shift_management.rotating_shifts.empty_rotating_shifts')}
              ctaButtonText={i18n.t('shift_management.rotating_shifts.add_rotating_shifts')}
              ctaButtonOnClick={onClick}
            />
          </Table.Body>
        </Table>
      ) : (
        <Box
          ref={scrollContainerRef}
          data-scroll-container
          width="full"
          overflowY="auto"
          style={{ maxHeight: 'calc(100vh - 415px)' }}
        >
          {loading ? (
            loadingSpinner
          ) : controls ? (
            <InfiniteScroll
              scrollContainerRef={scrollContainerRef}
              threshold={100}
              loadMore={controls.fetchMore}
              hasMore={controls.hasMore}
              loader={loadingSpinner}
            >
              {templateList}
            </InfiniteScroll>
          ) : (
            templateList
          )}
        </Box>
      )}

      {isModalOpen && <AddShiftTemplate onClose={onClose} />}
    </>
  )
}

export default observer(ShiftTemplatesSettings)
